package one.healthium.ui.compose.utils

expect fun targetPlatform(): TargetPlatform

enum class TargetPlatform {
    Android,
    IOS,
    Web
}
